import axios from 'axios'
import * as types from './types'

export default {
  [types.GET_TASKS]: ({ commit }, token) => {
    return axios.get(`/api/customers/${token}/plan-implementation/tasks`)
      .then((resp) => {
        commit(types.MUTATE_TASKS, resp.data.data)
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.CREATE_TASK]: ({ }, { token, ...payload }) => {
    return axios.post(`/api/customers/${token}/plan-implementation/tasks`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.UPDATE_TASK]: ({ }, { token, id, ...payload }) => {
    return axios.put(`/api/customers/${token}/plan-implementation/tasks/${id}`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.DELETE_TASK]: ({ }, { token, id }) => {
    return axios.delete(`/api/customers/${token}/plan-implementation/tasks/${id}`)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.GET_MILESTONES]: ({ commit }, token) => {
    return axios.get(`/api/customers/${token}/plan-implementation/milestones`)
      .then((resp) => {
        commit(types.MUTATE_MILESTONES, resp.data.data)
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.CREATE_MILESTONE]: ({ }, { token, ...payload }) => {
    return axios.post(`/api/customers/${token}/plan-implementation/milestones`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.UPDATE_MILESTONE]: ({ }, { token, id, ...payload }) => {
    return axios.put(`/api/customers/${token}/plan-implementation/milestones/${id}`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.DELETE_MILESTONE]: ({ }, { token, id }) => {
    return axios.delete(`/api/customers/${token}/plan-implementation/milestones/${id}`)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.GET_SECONDARY_GOALS]: ({ commit }, token) => {
    return axios.get(`/api/customers/${token}/plan-implementation/secondary-goals`)
      .then((resp) => {
        commit(types.MUTATE_SECONDARY_GOALS, resp.data.data)
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.CREATE_SECONDARY_GOAL]: ({ }, { token, ...payload }) => {
    return axios.post(`/api/customers/${token}/plan-implementation/secondary-goals`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.UPDATE_SECONDARY_GOAL]: ({ }, { token, id, ...payload }) => {
    return axios.put(`/api/customers/${token}/plan-implementation/secondary-goals/${id}`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.DELETE_SECONDARY_GOAL]: ({ }, { token, id }) => {
    return axios.delete(`/api/customers/${token}/plan-implementation/secondary-goals/${id}`)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
}
